import * as React from 'react'
import { debounce } from 'throttle-debounce'
import { Button, Input } from '@mobiscroll/react-latest'
import TeamMemberTable from '../../containers/team-members/TeamMemberTable'
import UIMessages from '../../utils/ui-messages'
import HorizontalSelector from '../HorizontalSelector'
import HorizontalSelectorItem from '../HorizontalSelectorItem'
import { IMemberFilters } from '../../types'
import { getAccessJwtPayload } from 'src/utils/auth'
import { handleRedirect } from 'src/utils'
import PreloaderCircle from '../ui/PreloaderCircle'
import FindIcon from '../icons/ui/Find'
import Plus from '../icons/organizations/Plus'

interface ITTPProps {
  currentOrgId: string
  updateTeamMemberFilters: (params: IMemberFilters) => Promise<any>
  resetTeamMemberFilters: () => Promise<void>
}

interface ITTPState {
  filters: IMemberFilters
  searchValue: string | undefined
  isLoading: boolean
}

export default class TeamMemberTablePane extends React.Component<ITTPProps, ITTPState> {
  public state: ITTPState = {
    filters: {
      isArchived: false,
      search: '',
      orgId: this.props.currentOrgId
    },
    searchValue: '',
    isLoading: true
  }

  public searchMembersDebounced = debounce(500, (search: string) => {
    this.setState({ filters: { ...this.state.filters, search } })
    this.props.updateTeamMemberFilters({ ...this.state.filters, search })
  })

  public componentDidMount() {
    if (this.props.currentOrgId) {
      const filterPayload: IMemberFilters = {}
      filterPayload.orgId = this.props.currentOrgId
      filterPayload.isArchived = this.state.filters.isArchived
      this.props.updateTeamMemberFilters(filterPayload)
      this.setState({ isLoading: false })
    }
  }

  public componentWillUnmount() {
    this.props.resetTeamMemberFilters()
  }

  public render() {
    const { filters } = this.state
    const accessJwtPayload = getAccessJwtPayload()
    const isAdmin =
      accessJwtPayload &&
      (accessJwtPayload.rolesInOrganizations
        .filter(org => org.organizationId === this.props.currentOrgId)[0]
        .roles.map(role => role.roleName)
        .includes('ORGANIZATION_ADMIN') ||
        false)

    if (this.state.isLoading) {
      return (
        <div>
          <PreloaderCircle loading={true} />
        </div>
      )
    }

    return (
      <React.Fragment>
        <div className='flex items-center justify-between p2'>
          <HorizontalSelector>
            <HorizontalSelectorItem isSelected={!filters.isArchived}>
              <div className='uppercase cursor--pointer' onClick={this.setArchived(false)}>
                {UIMessages.teamMember.teamMembers}
              </div>
            </HorizontalSelectorItem>
            <HorizontalSelectorItem isSelected={filters.isArchived}>
              <div className='uppercase cursor--pointer' onClick={this.setArchived(true)}>
                {UIMessages.teamMember.archivedTeamMembers}
              </div>
            </HorizontalSelectorItem>
          </HorizontalSelector>
          <div className='column-gap-8 flex flex-row'>
            <div className='flex items-center relative'>
              <Input
                className='mbsc-input-with-start-icon mbsc-input-with-start-icon-label RidersSearchInput'
                inputStyle='box'
                label={UIMessages.common.search}
                labelStyle='floating'
                theme='ios'
                type='text'
                value={this.state.searchValue}
                onChange={this.searchMembers}
              />
              <FindIcon className='absolute ml1 svg-stroke-grey2' />
            </div>
            {isAdmin && (
              <div className='flex items-center relative'>
                <Button
                  ariaLabel='Redirect to create team members component'
                  className='mbsc-btn-with-start-icon mbsc-success-btn'
                  onClick={() => handleRedirect('/team-members/create')}
                >
                  {UIMessages.teamMember.createNewTeamMember}
                </Button>
                <Plus className='absolute ml2 z1' />
              </div>
            )}
          </div>
        </div>
        <div>
          {/* To rerender TeamMember table so the props and state of the table is reset properly */}
          {this.state.filters.isArchived === true && <TeamMemberTable />}
          {this.state.filters.isArchived === false && <TeamMemberTable />}
        </div>
      </React.Fragment>
    )
  }

  private searchMembers = (e: any) => {
    const regex = /[\\\/\$\|\&\%\#\.\?]/g
    const search = e && e.target.value ? e.target.value.replaceAll(regex, '') : undefined
    this.setState({ searchValue: search })
    this.searchMembersDebounced(search)
  }

  private setArchived = (isArchived: boolean) => {
    return (e: any) => {
      this.setState({ filters: { ...this.state.filters, isArchived } })
      this.props.updateTeamMemberFilters({ ...this.state.filters, isArchived })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/team-members/TeamMemberTablePane.tsx